<template>
  <div class="storybook-template">
    <div class="fragment-component">
      <h2 class="heading">{{ title }}</h2>
      <CncButton v-if="pathFigma" name="Figma design" :rightIcon="{name:'ico_link'}" type="tonal" size="small" @click="redirectToFigma"/>
    </div>
    <div v-if="desc" class="m-t-20">
      <h4>Description : </h4>
      <div class="p-16 font-14px">{{ desc }}</div>
    </div>
    <div class="cnc-fragment m-t-20" :class="{ 'is-dark': isDark }">
      <div class="head">
        <el-switch v-model="isDark" class="small"/>
        <span class="m-l-8 font-bold">Background</span>
      </div>
      <div class="p-16">
        <slot/>
      </div>
    </div>

    <!-- prop detail (hide when propList is empty)-->
    <div v-if="propList && propList.length" class="m-t-20">
      <h4>Props:</h4>
      <div class="cnc-fragment table-wrapper m-t-20">
        <el-table :data="propList">
          <el-table-column label="Name" prop="name" width="160"/>
          <el-table-column label="Description" width="200">
            <template slot-scope="scope">
              <div v-if="scope.row.type === 'select'">{{ getListOption(scope.row) }}</div>
              <div v-else-if="scope.row.type === 'input'">String</div>
              <div v-else-if="scope.row.type === 'slider'">Number</div>
              <div v-else-if="scope.row.type === 'boolean'">Boolean</div>
              <div v-else-if="scope.row.type === 'object'">{{ getObject(scope.row) }}</div>
              <div v-else-if="scope.row.type === 'array'">Array</div>
            </template>
          </el-table-column>
          <el-table-column label="Default" prop="default" width="160"/>
          <el-table-column prop="type">
            <template slot-scope="scope">
              <div v-if="scope.row.type === 'select'">
                <el-select v-model="form[scope.row.param || scope.row.name]">
                  <el-option v-for="choice in scope.row.option" :key="choice.label" :value="choice.label">{{ choice.name }}</el-option>
                </el-select>
              </div>
              <div v-else-if="scope.row.type === 'input'">
                <el-input v-model="form[scope.row.param]" :placeholder="`Please input ${scope.row.name}`"/>
              </div>
              <div v-else-if="scope.row.type === 'slider'" class="p-10">
                <el-slider v-model="form[scope.row.param || scope.row.name]" :min="scope.row.min || 0" :max="scope.row.max || 300" show-input/>
              </div>
              <div v-else-if="scope.row.type === 'boolean'">
                <el-switch v-model="form[scope.row.param || scope.row.name]"/>
              </div>
              <div v-else-if="scope.row.type === 'object'">
                <div v-for="arg in scope.row.objectKey" :key="arg.key">
                  <div class="m-b-4">{{ arg.key }}</div>
                  <div v-if="arg.type === 'select'" class="m-b-10">
                    <el-select v-model="form[scope.row.param][arg.key]">
                      <el-option v-for="choice in arg.option" :key="choice" :value="choice">{{ choice }}</el-option>
                    </el-select>
                  </div>
                  <div v-else-if="arg.type === 'input'" class="m-b-10">
                    <el-input v-model="form[scope.row.param][arg.key]" :placeholder="`Please input ${arg.name}`" />
                  </div>
                  <div v-else-if="arg.type === 'boolean'" class="m-b-10 m-t-10">
                    <el-switch v-model="form[scope.row.param][arg.key]"/>
                  </div>
                </div>
              </div>
              <div v-else-if="scope.row.type === 'array'">
                <el-input v-model="formArray" type="textarea" :placeholder="`Please input ${scope.row.name}`" />
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div v-if="isShowCode" class="section-code" :class="{ 'm-t-20': propList && propList.length }">
      <h4>Code:</h4>
      <CodeBlock :content="codeBlockContent" />
    </div>
  </div>
</template>

<script>

export default {
  components: {
    CodeBlock: () => import('@/components/CodeBlock.vue')
  },
  props: {
    title: { type: String },
    desc: { type: String },
    pathComponent: { type: String },
    pathFigma: { type: String },
    propList: { type: Array },
    form: { type: Object, default: () => {} },
    isShowCode: { type: Boolean, default: true }
  },
  data () {
    return {
      isDark: false,
      formArray: JSON.stringify(this.form[this.propList[0].param], null)
    }
  },
  computed: {
    nameComponent () {
      return this.pathComponent.split('/').pop().split('.')[0] || this.title
    },
    codeBlockContent () {
      const component = `<${this.nameComponent} ${
        this.propList.map(prop => this.form[prop.param] === undefined ? '' : `:${prop.param}="${prop.type === 'array' || prop.type === 'object' ? JSON.stringify(this.form[prop.param]) : this.form[prop.param]}"`).join(' ')
      } />`
      return component
    }
  },
  watch: {
    formArray (newValue) {
      this.form[this.propList[0].param] = JSON.parse(newValue)
    }
  },
  methods: {
    getListOption (item) {
      const list = item.option || []
      if (list.length) return list.map(item => item.label).join(', ')
      else return ''
    },
    getObject (item) {
      const keyList = item.objectKey?.map(i => i.key)
      let keyText = keyList?.length ? keyList.join(', ') : item.objectKey
      return `Object: { ${keyText} }`
    },
    redirectToFigma () {
      window.open(this.pathFigma, '_blank')
    }
  }
}
</script>

<style lang="scss">
.storybook-template {
  .heading {
    margin-top: 0;
  }
  .fragment-component {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .cnc-fragment {
    min-height: 200px;
    border: 1px solid rgba(0,0,0,0);
    border-radius: 20px;
    background-color: white;
    box-shadow: 0px 0px 15px rgba(0,0,0,.15);
    overflow: auto;

    &.is-dark {
      background: #333;
    }

    .head {
      padding: 16px;
      background-color: #eee;
    }
  }

  .el-table {
    tr {
      th {
        vertical-align: top;
        color: #333;
        font-size: 16px !important;
        padding: 16px 12px;
      }

      td {
        vertical-align: top;
        font-size: 14px !important;
        padding: 6px 20px !important;

        .el-input .el-input__inner, .el-input .el-textarea__inner {
          padding: 6px 14px;
          font-size: 14px !important;
        }

        .cell {
          padding: 10px 4px !important;
        }
      }
    }
  }
}
</style>
